<script>
import Layout from '@layouts/default'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'

export default {
    page: {
        title: 'Восстановление пароля',
        meta: [
            { name: 'description', content: `Восстановление пароля ${appConfig.title}` },
        ],
    },
    components: { Layout },
    data() {
        return {
            phone     : '+7',
            password  : '',
            sms_code  : '',
            show_code : false,
            error     : null,
            show_password : false,
            confirm_uuid  : null,
            tryingToReset : false,
            isResetError  : false,
        }
    },
    computed: {},
    methods: {
        ...authMethods,

        async tryToReset() {

            this.tryingToReset = true;
            this.isResetError  = false;

            let data_send;
            let result;

            if(this.confirm_uuid == null){

                if(this.sms_code == ''){

                    // отправляем код
                    data_send = {
                        'phone': this.phone,
                    };

                } else {
                    data_send = {
                        'code'  : this.sms_code,
                        'phone' : this.phone
                    };
                }


                result = await this.$store.dispatch('users/FETCH_USERS_CONFIRM', data_send);

                if (result == false) {

                    this.tryingToReset = false;
                    this.error = 'Ошибка при подтверждении номера телефона';
                    this.isRegisterError = true;

                } else {

                    // показываем поле для ввода кода
                    this.show_code = true;

                    if(result !== null && result.confirm_uuid !== 'undefined'){
                        this.confirm_uuid  = result.confirm_uuid;
                        this.show_password = true;
                    }

                }

            } else {

                let data_send = {
                    'phone'        : this.phone,
                    'password'     : this.password,
                    'confirm_uuid' : this.confirm_uuid
                };

                let new_session = await this.$store.dispatch('users/FETCH_USERS_RECOVERY', data_send);

                if (new_session == false) {
                    this.tryingToReset = false;
                    this.regError = 'Ошибка при обновлении пароля';
                    this.isRegisterError = true;
                } else {
                    this.$router.push({name: 'login'});
                }

            }

        },
    },
}
</script>

<template>
	<Layout>
        <div class="account-pages my-5">
			<div class="container">
				<div class="row justify-content-center" style="margin-left: 0px; margin-right: 0px">
					<div class="col-xl-4 form" style="max-width: 400px">
						<div class="card">
							<div class="card-body p-0">
								<div class="row">
									<div class="col p-5">

                                        <div class="mx-auto mb-5" style="margin-left: 30px !important; margin-bottom: 70px !important; margin-top: 10px !important">
                                            <a routerLink="/">
                                                <img src="@assets/images/logo.png" alt style="margin-left: -25px;"/>
                                            </a>
                                        </div>

										<div class="mx-auto mb-5">
											<a href="/">
												<h3 class="d-inline align-middle ml-1 text-logo"
													>Личный кабинет</h3
												>
											</a>
										</div>

										<h6 class="h5 mb-0 mt-4">Сброс пароля</h6>
										<p class="text-muted mt-1 mb-5"
											>Введите номер телефона указанный при регистрации.</p
										>

										<b-alert
											v-model="isResetError"
											variant="danger"
											dismissible
											>{{ error }}</b-alert
										>

										<form
											action="#"
											class="authentication-form"
											@submit.prevent="tryToReset"
										>
											<div class="form-group">
												<label class="form-control-label">Номер телефона</label>
												<div class="input-group input-group-merge">
													<div class="input-group-prepend">
														<span class="input-group-text">
															<feather type="phone" class="icon-dual"></feather>
														</span>
													</div>
													<input
														id="phone"
														type="phone"
														class="form-control"
														placeholder="Номер телефона"
                                                        v-model="phone"
													/>
												</div>
											</div>

                                            <div v-show="show_code" class="form-group">
                                                <label class="form-control-label">Код подтверждения</label>
                                                <div class="input-group input-group-merge">
                                                    <div class="input-group-prepend">
														<span class="input-group-text">
															<feather type="key" class="icon-dual"></feather>
														</span>
                                                    </div>
                                                    <input
                                                        id="sms_code"
                                                        type="number"
                                                        class="form-control"
                                                        placeholder="Код из СМС сообщения"
                                                        v-model="sms_code"
                                                    />
                                                </div>
                                            </div>

                                            <div v-show="show_password" class="form-group">
                                                <label class="form-control-label">Новый пароль</label>
                                                <div class="input-group input-group-merge">
                                                    <div class="input-group-prepend">
														<span class="input-group-text">
															<feather type="lock" class="icon-dual"></feather>
														</span>
                                                    </div>
                                                    <input
                                                        id="password"
                                                        type="password"
                                                        class="form-control"
                                                        placeholder="Укажите новый пароль"
                                                        v-model="password"
                                                    />
                                                </div>
                                            </div>

                                            <div class="form-group mb-0 text-center">
												<button class="btn btn-primary btn-block" type="submit"
													>Продолжить</button
												>
											</div>
										</form>
                                        <div class="col-12 text-center" style="margin-top: 20px">
                                            <p class="text-muted">
                                                Вернуться для
                                                <router-link
                                                    tag="a"
                                                    to="/"
                                                    class="text-primary font-weight-bold ml-1"
                                                >Авторизации</router-link
                                                >
                                            </p>
                                        </div>
									</div>

								</div>
							</div>
							<!-- end card-body -->
						</div>
						<!-- end card -->

					</div>
					<!-- end col -->
				</div>
				<!-- end row -->
			</div>
			<!-- end container -->
		</div>
	</Layout>
</template>

<style lang="scss">

    .account-pages {
        width: 100vw; margin: 0 !important; min-height: 100vh;
    }

    .form-control {
        height: calc( 1.5em + 1rem + 3px );
    }

    .card {
        -webkit-box-shadow: 0px 5px 21px 6px rgba(34, 60, 80, 0.03);
        -moz-box-shadow: 0px 5px 21px 6px rgba(34, 60, 80, 0.03);
        box-shadow: 0px 5px 21px 6px rgba(34, 60, 80, 0.03);
    }

    .container {
        width: 100vw;
        margin: 0;
        padding: 0;
        max-width: 100vw !important;
        min-height: 100vh;
    }

    .row.justify-content-center {
        min-height: 100vh;
        align-items: center;
    }

    .row.justify-content-center .card {
        max-width: 400px;
    }

    .auth-page-sidebar {
        background-position-x: right;
        .overlay {
            display: none !important
        }
    }
</style>
